var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPinMid = function SvgPinMid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 38.4c-.2 0-.4-.1-.6-.3-.1-.1-2-2.6-4-6.3-1.2-2.2-2.1-4.3-2.8-6.4-.8-2.6-1.3-5-1.3-7.2 0-4.8 3.9-8.7 8.7-8.7s8.7 3.9 8.7 8.7c0 2.2-.4 4.6-1.3 7.2-.7 2-1.6 4.2-2.8 6.4-2 3.7-4 6.2-4 6.3-.2.2-.4.3-.6.3zM24 11c-4 0-7.2 3.2-7.2 7.2 0 4.7 2.1 9.6 3.9 12.9 1.3 2.4 2.6 4.3 3.3 5.4.7-1 2-2.9 3.3-5.4 1.8-3.3 3.9-8.2 3.9-12.9 0-4-3.2-7.2-7.2-7.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 22.6c-2.4 0-4.3-1.9-4.3-4.3S21.6 14 24 14s4.3 1.9 4.3 4.3-1.9 4.3-4.3 4.3zm0-7.3c-1.6 0-2.9 1.3-2.9 2.9 0 1.6 1.3 2.9 2.9 2.9 1.6 0 2.9-1.3 2.9-2.9 0-1.6-1.3-2.9-2.9-2.9z"
  })));
};
export default SvgPinMid;